import { ComponentPropsWithoutRef } from "react";
import { WrapperInteractionRoot } from "../wrappers/WrapperInteractionRoot";
import { MediaBackground } from "../components/MediaBackground";
import { MetaFunction } from "@remix-run/react";
import { CardText } from "../components/CardText";
import { WrapperDrawnBorder } from "../wrappers/WrapperDrawnBorder";
import { ButtonLink, LinkProps } from "../elements/ButtonLink";
import { ArrowRight } from "@untitled-ui/icons-react";
import { Paragraph } from "../elements/Paragraph";
import * as styles from "./SectionNotFound.css";
import { Media, MediaProps } from "../components/Media";
import { ImageProps } from "../elements/Image";
// @ts-ignore

export type SectionNotFoundProps = {
  link?: LinkProps;
  text?: string;
  backgroundSrc?: ImageProps;
  errorImageSrc?: ImageProps;
  layout?: "left" | "right";
} & ComponentPropsWithoutRef<"div">;

export const SectionNotFound = ({
  text,
  link,
  backgroundSrc = {
    src: "https://imagedelivery.net/5u-BnzY4d8R245ADRh1vnA/7b6d6328-de70-4800-dcfc-ca140db83800/public",
  },
  errorImageSrc = {
    src: "https://imagedelivery.net/5u-BnzY4d8R245ADRh1vnA/931ecce0-a19b-4f66-8c70-c1c31f6f0a00/public",
  },
  layout = "left",
  ...props
}: SectionNotFoundProps) => {
  return (
    <section
      style={{
        display: "grid",
        height: "100dvh",
        gridTemplateColumns: "1fr",
        gridTemplateRows: "1fr auto",
        overflow: "hidden",
        justifyContent: "center",
      }}
    >
      <WrapperInteractionRoot>
        <MediaBackground media={{ image: backgroundSrc }} />
        <div className={styles.layout({ layout: layout })}>
          <div className={styles.container}>
            <div className={styles.image}>
              <Media media={{ image: errorImageSrc }} />
            </div>
            <div className={styles.cta}>
              {text && (
                <WrapperDrawnBorder className={styles.textContainer}>
                  <Paragraph>{text}</Paragraph>
                </WrapperDrawnBorder>
              )}
              {link && (
                <ButtonLink
                  {...link}
                  icon={ArrowRight}
                  theme="dark"
                  width="full"
                >
                  <Paragraph>{link.title}</Paragraph>
                </ButtonLink>
              )}
            </div>
          </div>
        </div>
      </WrapperInteractionRoot>
    </section>
  );
};
